var ReactRedux = require("react-redux");
var Clinical = require('../components/clinical.jsx');

var mapStateToProps = function(state){
    return {
        auth: state.auth
    };
}

module.exports = ReactRedux.connect(mapStateToProps, null)(Clinical);



// WEBPACK FOOTER //
// ./src/common/routes/clinical/containers/clinical.jsx